import { Component, OnInit } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-success-add-to-cart',
  templateUrl: './dialog-success-add-to-cart.component.html',
  styleUrls: ['./dialog-success-add-to-cart.component.css']
})
export class DialogSuccessAddToCartComponent implements OnInit {

  constructor(
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  close(): void {
    this.dialog.closeAll();
  }

}
